export default "__VITE_ASSET__CT81FeOh__"